import { cn } from '@/lib/utils';

interface LogoMarkProps extends React.SVGAttributes<SVGSVGElement> {
  size?: number;
}

/* Square brand mark — the human+AI icon from the HumAIne brand identity.
 * A stylised H built from two vertical strokes with a crossbar, circle accents,
 * and curved arcs suggesting human posture and AI connectivity.
 * Inline SVG so it stays crisp at any size without font-loading concerns.
 */
export function LogoMark({ className, size = 32, ...props }: LogoMarkProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 260 260"
      width={size}
      height={size}
      fill="none"
      role="img"
      aria-label="HumAIne"
      className={cn('shrink-0', className)}
      {...props}
    >
      <defs>
        <linearGradient
          id="humaine-mark"
          x1="34"
          y1="32"
          x2="224"
          y2="226"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0%" stopColor="#6EE7F9" />
          <stop offset="48%" stopColor="#7C3AED" />
          <stop offset="100%" stopColor="#14B8A6" />
        </linearGradient>
      </defs>
      {/* Gradient rounded-square background */}
      <rect x="38" y="38" width="184" height="184" rx="52" fill="url(#humaine-mark)" />
      {/* H strokes */}
      <path d="M85 82V178" stroke="white" strokeWidth="18" strokeLinecap="round" />
      <path d="M175 82V178" stroke="white" strokeWidth="18" strokeLinecap="round" />
      <path d="M92 130H168" stroke="white" strokeWidth="18" strokeLinecap="round" />
      {/* Circle accents (human head / AI node) */}
      <circle cx="87" cy="77" r="13" fill="white" />
      <circle cx="173" cy="183" r="13" fill="white" />
      {/* Curved arcs suggesting connectivity */}
      <path
        d="M129 65C162 65 189 92 189 125"
        stroke="white"
        strokeWidth="8"
        strokeLinecap="round"
        opacity="0.72"
      />
      <path
        d="M71 135C71 168 98 195 131 195"
        stroke="white"
        strokeWidth="8"
        strokeLinecap="round"
        opacity="0.72"
      />
      {/* Backslash — cyan accent stroke splitting the H to imply \u00b7AI\u00b7 */}
      <path
        d="M89 84L171 176"
        stroke="#22D3EE"
        strokeWidth="13"
        strokeLinecap="round"
        opacity="0.95"
      />
    </svg>
  );
}
